const CP_ACTION_TYPES = {
  LOAD_CP: 'cp/LOAD_CP',
};

export default CP_ACTION_TYPES;
